import React from 'react';
import {observer} from 'mobx-react';
import TimesheetEditor from 'main/containers/time_tracking/components/TimesheetEditor';
import {withState} from 'shared/core';
import {auth} from 'main/tools';
import {Layout} from 'components';
import MyTimesheetState from 'main/containers/time_tracking/components/my_timesheet/state/MyTimesheetState';
import _ from 'lodash';

const MyTimesheetContainer = observer(({uiState}) => {
  const {sortedPayPeriods, selectedPayPeriod} = uiState;

  if (_.isEmpty(sortedPayPeriods)) return null;

  return (
    <div>
      <Layout>
        <TimesheetEditor
          payPeriods={sortedPayPeriods}
          employee={auth.employee}
          payPeriod={selectedPayPeriod}
          onPayPeriodSelected={(payPeriod) => uiState.selectPayPeriod(payPeriod)}
        />
      </Layout>
    </div>
  );
});

export default withState(MyTimesheetContainer, MyTimesheetState);
